var VehicleOnObjectsReport = (function () {
  var localTableUrl,
    editMode;
  var vehicles = [];

    var change = function() {
        $('[js=interruptReport]').hide();
        var from = $('#From').val();
        var to = $('#To').val();
        if (!from && !to) {
            var date = new Date;
            date.setDate(date.getDate() - 1);
            $('#From').data("DateTimePicker").date(date);
            $('#To').data("DateTimePicker").date(new Date);
        } else if (!from) {
            var momentTo = $('#To').data("DateTimePicker").date();
            var dateFrom = momentTo.toDate();
            dateFrom.setDate(dateFrom.getDate() - 1);
            $('#From').data("DateTimePicker").date(dateFrom);
        } else if (!to) {
            var momentFrom = $('#From').data("DateTimePicker").date();
            var dateTo = momentFrom.toDate();
            dateTo.setDate(dateTo.getDate() + 1);
            $('#To').data("DateTimePicker").date(dateTo);
        }
        // Отправка запроса на выполнение расчета
        $.ajax({
                url: Url.action('api/vehicleOnObjects/report/calc'),
                type: 'POST',
                dataType: 'json',
                data: {
                    From: $('#From').val(),
                    To: $('#To').val(),
                    SelectedContractorIds: $('#SelectedContractorIds').val(),
                    SelectedRoadIds: $('#SelectedRoadIds').val(),
                    SelectedSectionServiceIds: $('#SelectedSectionServiceIds').val(),
                    SelectedVehicleIds: $('#SelectedVehicleIds').val(),
                    TimeOnObject: $('#TimeOnObject').val()
                }
            })
            .done(function(result) {
                if (result.error) {
                    $.each($('.field-validation-valid.text-danger'),
                        function(idx, span) {
                            if ($(span).data('valmsgFor') === result.field) {
                                $(span).text(result.text);
                            }
                            $('#SelectedContractorIds,#SelectedRoadIds,#SelectedVehicleIds,#From,#To')
                                .on('change',
                                    function() {
                                        $(span).text('');
                                    });
                        });
                } else {
                    $('[js=exportToExcel]').attr('disabled', 'disabled');
                    $('[js=reportGroupBy]').attr('disabled', 'disabled');
                    $('[js=applyFilter]').attr('disabled', 'disabled');
                    $('[js=clearFilter]').attr('disabled', 'disabled');
                    $('[js=interruptReport]').removeAttr('disabled');
                    $('[js=interruptReport]').show();
                    $('#VehicleOnObjectReportTable_processing,#VehicleOnObjectReportTableEdit_processing')
                        .attr('style', 'display: block;');
                    $('#Status').val(ReportStatuses.InProcess);
                    window.globalReportsId.VehicleOnObj = result;
                    localStorage.setItem('globalReportsId', JSON.stringify(window.globalReportsId));
                }
                window.trackUrls.length = 0;
            });
    };

    var init = function() {
        window.trackUrls.length = 0;
        if (editMode) {
            $(".select2").select2({
                placeholder: 'Введите транспортные средства',
            });
        } else {
            var $select2 = $('.select2').select2();

            $.each($('.select2-selection__choice'),
                function(idx, obj) {
                    var option = Select2Helper().findOption($(obj));
                    var classes = option.attr("class");

                    $(obj).attr("class", "select2-selection__choice " + classes);
                });

            $('.select2-selection__choice').on('click',
                function() {
                    var option = Select2Helper().findOption($(this));
                    var href = option.data("href");

                    if (href) {
                        location.href = href;
                    }
                });
        }
        ChosenSelect.Init();
        datetimepickerRangeInit({ $inputFrom: $('#From'), $inputTo: $('#To'), withSeconds: true });

        $('#SelectedSectionServiceIds').on('change',
            function() {
                if (!$('#SelectedRoadIds').data('disabled')) {
                    var values = $(this).val();
                    if (values && values.length > 0) {
                        $('#SelectedRoadIds').attr('disabled', 'disabled');
                        $('#SelectedRoadIds').trigger('chosen:updated');
                    } else {
                        $('#SelectedRoadIds').removeAttr('disabled');
                        $('#SelectedRoadIds').trigger('chosen:updated');
                    }
                }
            });
        $('#SelectedRoadIds').on('change',
            function() {
                var values = $(this).val();
                if (values && values.length > 0) {
                    $('#SelectedSectionServiceIds').find('option').hide();
                    for (var i = 0; i < values.length; i++) {
                        $('#SelectedSectionServiceIds').find('option[data-road-id="' + values[i] + '"]').show();
                    }
                    $('#SelectedSectionServiceIds').trigger('chosen:updated');
                } else {
                    $('#SelectedSectionServiceIds').find('option').show();
                    $('#SelectedSectionServiceIds').trigger('chosen:updated');
                }
            });
    };

    var interrupt = function() {
        var reportId = '';
        if (localStorage.getItem('globalReportsId')) {
            var globalReportId = JSON.parse(localStorage.getItem('globalReportsId'));
            reportId = globalReportId.VehicleOnObj;
        }
        $.ajax({
            url: Url.action('api/vehicleOnObjects/report/interrupt'),
            type: 'POST',
            dataType: 'json',
            data: {
                reportId: reportId
            }
        }).complete(function() {
            $('[js=interruptReport]').attr('disabled', 'disabled');
        });
    };

    var clearFilter = function () {

        var date = new Date;
        date.setDate(date.getDate() - 1);
        $('#From').data("DateTimePicker").date(date);
        $('#To').data("DateTimePicker").date(new Date);

        $('#TimeOnObject').val('0');

        $('#SelectedSectionServiceIds').val(null);
        $('#SelectedSectionServiceIds').find('option').show();
        $('#SelectedSectionServiceIds').trigger('chosen:updated');

        $('#SelectedRoadIds').val(null);
        $('#SelectedRoadIds').find('option').show();
        $('#SelectedRoadIds').removeAttr('disabled');
        $('#SelectedRoadIds').trigger('chosen:updated');

        $('#SelectedVehicleIds').val(null);
        $('#SelectedVehicleIds').trigger('chosen:updated');

        $('#SelectedContractorIds').val(null);
        $('#SelectedContractorIds').trigger('chosen:updated');
    };

  var tableOption = function (localTableUrl, checkedRows, $table) {
    return {
      language: {
        url: localTableUrl,
        select: {
          rows: "Выбрано %d строк"
        }
      },
      processing: false,
      pageLength: 100,
      lengthMenu: [10, 25, 50, 100],
      searching: false,
      dom: "<'row'<'col-sm-6'l><'col-sm-6 text-right top-paginate'p>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      columnDefs: [
        {
          orderable: false,
          visible: true,
          targets: 0
        },
        {
          orderable: false,
          targets: 1,
          visible: true,
        },
        {
          orderable: false,
          targets: 2,
          visible: true,
        },
        {
          orderable: false,
          targets: 3,
          visible: true,
        },
        {
          orderable: false,
          targets: 4,
          visible: true,
        },
        {
          orderable: false,
          targets: 5,
          visible: true,
        },
        {
          orderable: false,
          targets: 6,
          visible: true,
        },
        {
          orderable: false,
          targets: 7,
          visible: true,
        }
      ],
      order: false,
      initComplete: function () {
          $('<div class="toolbar__element"><span>Группировать по </span><select js="reportGroupBy" class="form-control input-sm valid"><option value="false">Автодорогам</option><option value="true">ТС</option></select></div>')
          .remove()
          .appendTo($('#VehicleOnObjectReportTable_wrapper .col-sm-6:eq(0),#VehicleOnObjectReportTableEdit_wrapper .col-sm-6:eq(0)'));
        //Используется для кэширования html-разметки диалога "Треков ТС"
        $('<button class="btn btn-sm btn-default btn-table-menu pull-right" js="show-tracks" type="button" disabled="disabled"><i class="fa show-track-td"></i></button>')
          .remove()
            .appendTo($('#VehicleOnObjectReportTable_wrapper .col-sm-6:eq(1),#VehicleOnObjectReportTableEdit_wrapper .col-sm-6:eq(1)'));
          if (editMode) {
              $('<button class="btn btn-sm btn-default btn-table-menu pull-right" js="fill-work" type="button" disabled="disabled"><i class="fa btn-fill-work"></i></button>')
                  .remove()
                  .appendTo($('#VehicleOnObjectReportTableEdit_wrapper .col-sm-6:eq(1)'));
          }
          $('[js=reportGroupBy]').val($('#ByVehicle').val().toLowerCase());
          $('[js=reportGroupBy]').on('change', function (e) {
              $('#ByVehicle').val(this.value);
              reloadReport(window.globalReportsId.VehicleOnObj, window.globalReportsId.ObjId, _reInit, true);
          });
      },
      select: {
        style: 'multi',
        selector: 'td:first-child'
      }
    };
  }

  function tableInit () {
    var tracksUrl = Url.action('api/vehicles/track=ids@from-to');
    var checkedRows = [];
    vehicles = [];
    var $table = $('#VehicleOnObjectReportTable,#VehicleOnObjectReportTableEdit');
    var checkAll = $table.find('[js=checkAll]');

      var table = $table.DataTable(tableOption(localTableUrl, checkedRows, $table))
          .on('page.dt', function(e, settings) {
              checkAllItem();
          })
          .on('select', function (event, api, type, index) {
              var currentTable = this;
              var start = api.page.info().start;
              $.each(index, function(idx, number) {
                  var rowId = api.row(number).id();

                  if (!checkedRows.contains(number)) {
                      if (rowId && rowId != "undefined") {
                          checkedRows.push(number);
                          $('[js=show-tracks]').removeAttr('disabled');
                      } else {
                          table.rows(api.row(number)).deselect();
                      }
                  }

                  if (Number(rowId)) {
                      var trIndex = number - start;
                      var $row = $(currentTable).find('tbody tr:eq(' + trIndex + ')');
                      // Формируем список Url для построения треков
                      var vehicleId = $row.data('id');
                      var startTime = api.row(number).data()[1];
                      var stopTime = api.row(number).data()[2];
                      window.trackUrls.push(generateUrl(vehicleId, startTime, stopTime));

                      if (editMode) {
                          var contractorId = $row.data('contractor-id');
                          var roadId = $row.data('road-id');
                          var startKm = parseFloat($row.attr('data-start-km').replace(/,/, '.'));
                          var stopKm = parseFloat($row.attr('data-stop-km').replace(/,/, '.'));
                          vehicles.push({
                              vehicleId: vehicleId,
                              contractorId: contractorId,
                              roadId: roadId,
                              startTime: startTime,
                              stopTime: stopTime,
                              startKm: startKm,
                              stopKm: stopKm
                          });
                      }
                  }
              });

              checkAllItem();
              if (editMode) {
                  if (canFillWork())
                      $('[js=fill-work]').removeAttr('disabled');
                  else
                      $('[js=fill-work]').attr('disabled', 'disabled');
              }
          })
          .on('deselect', function (event, api, type, index) {
              var currentTable = this;
              var start = api.page.info().start;
              $.each(index, function(idx, number) {
                  var rowId = api.row(number).id();
                  checkedRows.removeValue(number);

                  if (Number(rowId)) {
                      var trIndex = number - start;
                      var $row = $(currentTable).find('tbody tr:eq(' + trIndex + ')');
                      // Актуализуем список Url для построения треков
                      var vehicleId = $row.data('id');
                      var startTime = api.row(number).data()[1];
                      var stopTime = api.row(number).data()[2];
                      var removedUrlData = generateUrl(vehicleId, startTime, stopTime);
                      window.trackUrls = window.trackUrls.filter(function(urlData) {
                          return urlData.url !== removedUrlData.url && urlData.data.from !== removedUrlData.data.from && urlData.data.to !== removedUrlData.data.to;
                      });
                      if (editMode) {
                          var contractorId = $row.data('contractor-id');
                          var roadId = $row.data('road-id');
                          var startKm = parseFloat($row.attr('data-start-km').replace(/,/, '.'));
                          var stopKm = parseFloat($row.attr('data-stop-km').replace(/,/, '.'));
                          vehicles = vehicles.filter(function(vehicle) {
                              return vehicle.vehicleId !== vehicleId ||
                                  vehicle.contractorId !== contractorId ||
                                  vehicle.roadId !== roadId ||
                                  vehicle.startTime !== startTime ||
                                  vehicle.stopTime !== stopTime ||
                                  vehicle.startKm !== startKm ||
                                  vehicle.stopKm !== stopKm;
                          });
                      }
                  }
              });

              checkAllItem();
              if (checkedRows.length === 0) {
                  $('[js=show-tracks]').attr('disabled', 'disabled');
              }
              if (editMode) {
                  if (canFillWork())
                      $('[js=fill-work]').removeAttr('disabled');
                  else
                      $('[js=fill-work]').attr('disabled', 'disabled');
              }

          });

    function checkAllItem() {
      // Кол-во выбранных строк
      var rowsSelectedCount = 0;
      // Кол-во строк которые можно выбрать
      var rowsAllCount = 0;
      var info = table.page.info();
      for (var i = info.start; i < info.end ; i++) {
        if (Number(table.row(i).id())) {
          rowsAllCount++;
          if (checkedRows.contains(i)) {
            rowsSelectedCount++;
          }
        }
      }
      checkAll.toggleClass('selected', rowsSelectedCount === rowsAllCount);
    }

    function canFillWork() {
        if (vehicles.length === 0)
            return false;
        if (vehicles.length === 1)
            return true;

        var vehicleId = vehicles[0].vehicleId;
        var roadId = vehicles[0].roadId;
        for (var i = 1; i < vehicles.length; i++) {
            if (vehicles[i].vehicleId !== vehicleId || vehicles[i].roadId !== roadId)
                return false;
        }

        return true;
    }

    checkAll.on('click', function () {
      var checkVal = checkAll.toggleClass('selected').hasClass('selected');
      var selectedRow = [];

      var info = table.page.info();
      for (var i = info.start; i < info.end ; i++) {
        if (Number(table.row(i).id())) {
          selectedRow.push(i);
        }
      }

      if (checkVal) {
        table.rows(selectedRow).select();
      } else {
        table.rows(selectedRow).deselect();
      }
    });

    return table;
  }

  function generateUrl(vehicleId, startDate, stopDate) {
    return {
      url: Url.action('api/vehicles/{0}/track'.format(vehicleId)),
      data: {
        from: startDate,
        to: stopDate
      }
    };
  }

  // Функция для построения отчета с вкладки "Отчеты"
  var initPage = function (option) {
    localTableUrl = Url.content('Content/Inspinia/plugins/dataTables/languages/Russian.json');
    editMode = option.editMode;

    var table = _reInit();

    if (Number($('#Status').val()) === ReportStatuses.InProcess) {
      $('[js=exportToExcel]').attr('disabled', 'disabled');
      $('[js=applyFilter]').attr('disabled', 'disabled');
      $('[js=clearFilter]').attr('disabled', 'disabled');
      $('[js=reportGroupBy]').attr('disabled', 'disabled');
      $('[js=interruptReport]').show();
      $('#VehicleOnObjectReportTable_processing,#VehicleOnObjectReportTableEdit_processing').attr('style', 'display: block;');
    }
  }

    var getSelectedVehicles = function() {
        return vehicles;
    }

  //
  function _reInit() {
    localTableUrl = Url.content('Content/Inspinia/plugins/dataTables/languages/Russian.json');

    var table = tableInit();
    init();

    return table;
  }

  return {
    Init: initPage,
    Change: change,
    ReInit: _reInit,
    Interrupt: interrupt,
    ClearFilter: clearFilter,
    GetSelectedVehicles: getSelectedVehicles
  };
}());
